import clsx from 'clsx'
import { AnimatePresence } from 'framer-motion'
import { useAtomValue } from 'jotai'
import useToggle from 'src/common/hooks/helpers/useToggle'
import { Offer } from 'src/common/types/models/Offer'
import Collapse from 'src/common/ui-kit/Animations/Collapse'
import Badge from 'src/common/ui-kit/Badge'
import Icon from 'src/common/ui-kit/Icon/Icon'
import {
  activeTabAtom,
  editOfferAtom,
} from 'src/pages/DiscoverPage/discover-store'
import OfferBadges from '../OfferBadges/OfferBadges'
import {
  getIsShowBadgeByTab,
  getMarketPriceBadgeForOffer,
} from '../OfferBadges/utils'
import OfferDetails from '../OfferDetails/OfferDetails'
import OfferPrice from './OfferPrice'
import OfferTokens from './OfferTokens'
import { useState } from 'react'

interface OfferRowProps {
  offer: Offer
  initialDetails?: boolean
}

const OfferRow: React.FC<OfferRowProps> = ({ offer, initialDetails }) => {
  const { isOn, toggle } = useToggle(initialDetails)
  const activeTab = useAtomValue(activeTabAtom)
  const editOffer = useAtomValue(editOfferAtom)
  const [canceled, setCanceled] = useState(false)
  const handleCanceled = () => {
    setCanceled(true)
    if (isOn) toggle()
  }

  const priceBadge = getMarketPriceBadgeForOffer(offer)

  const isEditing = editOffer.open && editOffer.offer?.id === offer.id

  return (
    <div>
      <div
        className={clsx(
          'comp-offer-row',
          isEditing ? 'border-primary' : 'border-transparent',
          canceled && 'opacity-80 grayscale pointer-events-none'
        )}
        onClick={() => toggle()}
      >
        <div className='comp-offer-left-block'>
          <OfferTokens
            offerStatus={offer.offerStatus}
            availableAmount={offer.availableAmount}
            amountIn={offer.amountIn}
            amountOut={offer.amountOut}
            depositAsset={offer.depositAsset}
            withdrawalAsset={offer.withdrawalAsset}
            swap={activeTab === 'my'}
          />
        </div>
        <div className='comp-offer-right-block'>
          <div className='flex flex-row items-center gap-1'>
            <OfferPrice
              amountIn={offer.amountIn}
              amountOut={offer.amountOut}
              depositAsset={offer.depositAsset}
              withdrawalAsset={offer.withdrawalAsset}
            />
            {priceBadge && getIsShowBadgeByTab(activeTab, priceBadge) && (
              <Badge
                key={priceBadge?.label}
                className='pointer-events-none'
                size='md'
                color={priceBadge?.color}
                badgeType={priceBadge?.type}
              >
                {priceBadge?.label}
              </Badge>
            )}
          </div>
          <OfferBadges canceled={canceled} offer={offer} />
        </div>
        {!canceled && (
          <Icon
            className={clsx({ 'rotate-180': isOn })}
            name='arrow-down'
            strokeWidth='0.1px'
          />
        )}
      </div>
      <AnimatePresence initial={false}>
        {isOn && (
          <Collapse>
            <OfferDetails offer={offer} onCancel={handleCanceled} />
          </Collapse>
        )}
      </AnimatePresence>
    </div>
  )
}

export default OfferRow
